import React from "react";
import { styled } from "@mui/material/styles";
import { TableRow, TableCell } from "@mui/material";
import colors from "assets/theme-dark/base/colors";
import { TableSegment } from "../../utils/segmentationTableUtils";
import { AnalysisDriverType } from "../../types/types";
import { formatDriverHeader } from "../../utils/excel/createHeaders";
import { cruxyColors } from "../../theme/color-palette";
import HeaderSelect from "./SegmentationHeaderSelect";
import TruncatedText from "../TruncatedText";

interface HeaderRowProps {
  segments: TableSegment[];
  selectableHeader1: string;
  selectableHeader2: string;
  headerOptions: string[];
  setSelectableHeader1: (header: string) => void;
  setSelectableHeader2: (header: string) => void;
  driver1Type: string;
  driver2Type: string;
  driver1Mode: AnalysisDriverType;
  driver2Mode: AnalysisDriverType;
  driver1NumeratorType: string;
  driver2NumeratorType: string;
  hasOneDataAndOneManualSegment: boolean;
  isManualOnly: boolean;
  isDataOnly: boolean;
}

const HeaderRow: React.FC<HeaderRowProps> = ({
  segments,
  selectableHeader1,
  selectableHeader2,
  headerOptions,
  setSelectableHeader1,
  setSelectableHeader2,
  driver1Type,
  driver2Type,
  driver1Mode,
  driver2Mode,
  driver1NumeratorType,
  driver2NumeratorType,
  hasOneDataAndOneManualSegment,
  isManualOnly,
  isDataOnly,
}) => {
  const segmentsColSpan =
    segments.length === 0 ? 2 : hasOneDataAndOneManualSegment ? 2 : isManualOnly || isDataOnly ? 2 : segments.length;

  return (
    <TableRow>
      <HeaderTableCell colSpan={segmentsColSpan} align="center">
        Segments
      </HeaderTableCell>
      <HeaderTableCell align="center"># Total</HeaderTableCell>
      <HeaderTableCell align="center">
        <HeaderSelect
          value={selectableHeader1}
          onChange={setSelectableHeader1}
          options={headerOptions}
          label="# Customers"
        />
      </HeaderTableCell>
      <HeaderTableCell align="center">
        <HeaderSelect
          value={selectableHeader2}
          onChange={setSelectableHeader2}
          options={headerOptions}
          label="# Prospects"
        />
      </HeaderTableCell>
      <HeaderTableCell colSpan={5} align="center">
        <TruncatedText
          text={`Total Initial ${formatDriverHeader(1, driver1Type, driver1NumeratorType, driver1Mode)}`}
          maxLength={30}
        />
      </HeaderTableCell>
      <HeaderTableCell colSpan={5} align="center">
        <TruncatedText
          text={`Total Initial ${formatDriverHeader(2, driver2Type, driver2NumeratorType, driver2Mode)}`}
          maxLength={30}
        />
      </HeaderTableCell>
    </TableRow>
  );
};

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${colors.grey[300]}`,
  padding: theme.spacing(1.5),
  fontSize: "0.85rem",
  backgroundColor: cruxyColors.blue.main,
  color: colors.white.main,
  fontWeight: "bold",
}));

export default HeaderRow;
